/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React from 'react';

import { useOverlayFormWithControlsStyles } from './OverlayFormWithControls.styles';

type HTMLFormProps = React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

type OverlayFrameWithControlsProps = HTMLFormProps & {
  stepsIndicator?: React.ReactNode;
  buttons?: React.ReactNode | ReadonlyArray<React.ReactNode>;
  disableFormGrow?: boolean;
};

export function OverlayFormWithControls(props: OverlayFrameWithControlsProps) {
  const { className, children, stepsIndicator, buttons, disableFormGrow, ...otherProps } = props;
  const classes = useOverlayFormWithControlsStyles();
  return (
    <form
      className={cx(className, classes.form, {
        [classes.formNotGrow]: disableFormGrow,
      })}
      {...otherProps}
    >
      <div className={classes.formChildren}>{children}</div>
      {(buttons || stepsIndicator) && (
        <div className={classes.formControls}>
          {buttons && <div className={classes.formButtons}>{buttons}</div>}
          {stepsIndicator && <div className={classes.stepsIndicator}>{stepsIndicator}</div>}
        </div>
      )}
    </form>
  );
}
